if($('header#header').length){
    $('.responsive-tools').append($('.top-navigation-tools .top-nav-button').clone())
}